export default "__VITE_ASSET__C5A1dWKr__"